import http from 'plugins/axios'

export default {
  getBannerList(data) {
    return http.post({
      url: '/ta/admin/banner/list',
      data,
      dataType: 'form',
    })
  },
  //获取商户id列表
  getTentIdlist() {
    return http.get({
      url: '/ta/admin/tenant/info',
    })
  },
  getBannerDetail(id) {
    return http.get({
      url: `/ta/admin/banner/detail/${id}`,
    })
  },
  createBanner(data) {
    return http.post({
      url: '/ta/admin/banner/add',
      data,
      dataType: 'form',
    })
  },
  updateBanner(data) {
    return http.post({
      url: '/ta/admin/banner/update',
      data,
      dataType: 'form',
    })
  },
  removeBanner(id) {
    return http.get({
      url: `/ta/admin/banner/delete/${id}`,
    })
  },
  updateSort(data) {
    return http.post({
      url: '/ta/admin/banner/sort',
      data,
      dataType: 'form',
    })
  },
  getbannerType(data) {
    return http.get({
      url: '/ta/admin/banner/bannerType',
      data,
    })
  },
  getLanguageList(data) {
    return http.get({
      url: '/ta/admin/banner/language',
      data,
    })
  },
}
